<template>
  <div class="pipedrive">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Pipedrive CRM <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  title="Configurações"
                  size="6"
                  color="black"
                  @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  title="Configurações"
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="pipedrive"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com o Pipedrive CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between align-items-center">
            <h4 class="modal-title">Configurar Pipedrive CRM</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="errorAlert" />
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Usuário Pipedrive</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="userId"
                  v-model="userId">
                  <option
                    v-for="option in usersOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Chamada Atendida</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="activityTypeKeyAnswered"
                  v-model="activityTypeKeyAnswered">
                  <option
                    v-for="option in activityTypesOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Chamada Não Atendida</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="activityTypeKeyNotAnswered"
                  v-model="activityTypeKeyNotAnswered">
                  <option
                    v-for="option in activityTypesOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">Salvar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Pipedrive atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Pipedrive removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialPipedrive"
      title="Tutorial Pipedrive"
      video-url="https://www.youtube.com/embed/ZTSwanYpEZk" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationPipedrive',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      authorizationCode: this.$route.query.code,
      userId: null,
      usersOptions: [],
      activityTypeKeyAnswered: null,
      activityTypeKeyNotAnswered: null,
      activityTypesOptions: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations?filter[where][gateway]=pipedrive`)
          .then(integrations => {
            this.integration = integrations.pop()
            if (this.integration && this.integration.metadata) {
              if (this.integration.metadata.userId) this.userId = this.integration.metadata.userId
              if (this.integration.metadata.activityTypeKeyAnswered) this.activityTypeKeyAnswered = this.integration.metadata.activityTypeKeyAnswered
              if (this.integration.metadata.activityTypeKeyNotAnswered) this.activityTypeKeyNotAnswered = this.integration.metadata.activityTypeKeyNotAnswered
            }
            return resolve()
          })
          .catch(err => { this.$emit('onError', err) })
      })
    },
    saveIntegration (authorizationCode) {
      return new Promise(resolve => {
        this.error = null
        if (!this.configReady) {
          this.error = 'Houve um erro ao salvar a integração. Por favor, tente novamente.'
          return resolve()
        }

        const integrationParams = {
          gateway: 'pipedrive',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'pipedrive'
            }
          },
          metadata: {
            webhookUrl: process.env.API4COM_WEBHOOK_RECEIVER_URL,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        if (this.integration) integrationParams.id = this.integration.id
        if (this.integration && this.integration.metadata) integrationParams.metadata = Object.assign(this.integration.metadata, integrationParams.metadata)

        if (this.userId) integrationParams.metadata.userId = this.userId
        else delete integrationParams.metadata.userId

        if (this.activityTypeKeyAnswered) integrationParams.metadata.activityTypeKeyAnswered = this.activityTypeKeyAnswered
        else delete integrationParams.metadata.activityTypeKeyAnswered

        if (this.activityTypeKeyNotAnswered) integrationParams.metadata.activityTypeKeyNotAnswered = this.activityTypeKeyNotAnswered
        else delete integrationParams.metadata.activityTypeKeyNotAnswered

        if (authorizationCode && typeof authorizationCode === 'string') integrationParams.metadata.authorizationCode = authorizationCode

        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
            return resolve()
          })
          .catch(err => {
            this.error = err
          })
      })
    },
    toogleIntegration (event) {
      if (event.value === true) {
        return this.requestAuthorization()
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      this.error = null
      this.configReady = false
      this.loadUsers().then(_ => {
        this.loadActivityTypes().then(_ => {
          this.configReady = true
        })
      })
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.configReady = false
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    requestAuthorization () {
      return loopback
        .get(`/integrations/pipedrive/authorize-link`)
        .then(link => {
          window.open(link, '_self')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    loadUsers () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations/pipedrive/users`)
          .then(users => {
            if (users && users.length > 0) {
              this.usersOptions = [{ value: null, text: 'Associação automática pelo Pipedrive' }]
              users.filter(u => u.active_flag).forEach(user => {
                this.usersOptions.push({
                  value: user.id,
                  text: `${user.name} (${user.email})`
                })
              })
              return resolve()
            } else {
              return resolve()
            }
          })
          .catch(err => { this.$emit('onError', err) })
      })
    },
    loadActivityTypes () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations/pipedrive/activity-types`)
          .then(activityTypes => {
            if (activityTypes && activityTypes.length > 0) {
              this.activityTypesOptions = [{ value: null, text: 'Associação automática pelo Pipedrive' }]
              activityTypes.filter(activityType => activityType.active_flag === true).forEach(activityType => {
                this.activityTypesOptions.push({
                  value: activityType.key_string,
                  text: `${activityType.name} (ícone: ${activityType.icon_key})`
                })
              })
              return resolve()
            } else {
              return resolve()
            }
          })
          .catch(err => { this.$emit('onError', err) })
      })
    },
    openTutorial () {
      this.$refs.tutorialPipedrive.open()
    }
  },
  computed: {
    // TEL-2243: esta tela guarda `error` como string escrita por ela mesma. O
    // ErrorAlert so aceita objeto — sem este envelope a validacao de prop reprova
    // e a tela nao renderiza erro nenhum. Mesmo padrao das telas de CRM irmas.
    errorAlert () {
      if (!this.error) return null
      return typeof this.error === 'string' ? { lines: [this.error] } : this.error
    },
    activeIntegration () {
      return this.integration && this.integration.gateway === 'pipedrive'
    }
  },
  watch: {
    authorizationCode: {
      handler: function authorizationCodeObserver (value) {
        if (value) {
          this.configReady = true
          this.saveIntegration(value).then(_ => this.$router.replace({ query: null }))
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/Pipedrive.vue